// Shopify API Configuration for Color Swatches
// This file contains the API configuration for GraphQL integration

(function() {
  'use strict';
  
  // Get the current hostname for the shop domain
  const getShopDomain = () => {
    return 'afends.myshopify.com';
  };
  
  // Your Storefront API access token - ADD YOUR TOKEN HERE
  const getStorefrontToken = () => {
    return 'c9f11cac50fd71c0b6b9cbaa814f71eb';
  };
  
  // API endpoint - version is automatically handled by Shopify app settings
  const getApiEndpoint = () => {
    return `https://${getShopDomain()}/api/2025-07/graphql.json`;
  };
  
  // Initialize the global Shopify config
  window.SHOPIFY_CONFIG = {
    shopDomain: getShopDomain(),
    storefrontToken: getStorefrontToken(),
    apiEndpoint: getApiEndpoint()
  };
  
  // Log configuration status
  /*console.log('🔑 Shopify API Config loaded:', {
    shopDomain: window.SHOPIFY_CONFIG.shopDomain,
    hasToken: !!window.SHOPIFY_CONFIG.storefrontToken,
    apiEndpoint: window.SHOPIFY_CONFIG.apiEndpoint
  });*/
  
  // Export for module usage if needed
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      getShopDomain,
      getStorefrontToken,
      getApiEndpoint
    };
  }
})();
